import { render, staticRenderFns } from "./WiiMenu.vue?vue&type=template&id=1b7405f6&"
import script from "./WiiMenu.vue?vue&type=script&lang=js&"
export * from "./WiiMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports